import React, { useEffect } from "react";
import { API } from "src/api/request";

const Dashboard = () => {
  useEffect(() => {
    API().get("", { params: {} });
  }, []);

  return (
    <div className="card">
      <div className="card-header">Card header</div>
    </div>
  );
};

export default Dashboard;
